<template>
  <div id="plan_view" v-if="plan">
    <div class="plan-hero">
      <div class="plan-hero-inner centered">
        <router-link to="/" class="back-link"><i class="fas fa-arrow-right"></i> חזרה לדף הבית</router-link>
        <h1 class="plan-hero-title">הצטרף ל-<span class="accent">WizzoStream</span></h1>
        <p class="plan-hero-sub">הגדר את חשבון הוידאו שלך בדקות ספורות</p>
      </div>
    </div>

    <div class="plan-body centered">
      <div class="plan-content">
        <div class="plan-sidebar">
          <div class="plan-card">
            <div class="plan-card-header">
              <span class="plan-badge">התוכנית שנבחרה</span>
              <h3 class="plan-name" v-text="plan.name"></h3>
            </div>
            <div class="plan-price-row">
              <span class="plan-price" v-text="displayPrice"></span>
              <span class="plan-currency">₪</span>
              <span class="plan-period" v-text="plan.text_ander_praice"></span>
            </div>
            <div class="plan-vat"><small>כולל מע"מ</small></div>
            <ul class="plan-features">
              <li v-if="plan.text_field_a"><i class="fas fa-check"></i> <span v-text="plan.text_field_a"></span></li>
              <li v-if="plan.text_field_b"><i class="fas fa-check"></i> <span v-text="plan.text_field_b"></span></li>
              <li v-if="plan.text_field_c"><i class="fas fa-check"></i> <span v-text="plan.text_field_c"></span></li>
              <li v-if="plan.text_field_d"><i class="fas fa-check"></i> <span v-text="plan.text_field_d"></span></li>
            </ul>
            <router-link to="/#plans" class="change-plan">שנה תוכנית</router-link>
          </div>
        </div>

        <div class="plan-main">
          <!-- self signup and card collection are closed here (chat #2384): a WizzoStream account opens in the Wizzo market -->
          <div class="form-card market-door">
            <div class="door-icon"><i class="fas fa-store"></i></div>
            <h2 class="form-title">ההרשמה עברה למרקט של Wizzo</h2>
            <p class="door-text">חשבון חדש ב-WizzoStream נפתח עכשיו במרקט של Wizzo, ושם גם מזינים את כרטיס האשראי.</p>
            <a :href="market_url" class="submit-btn">להרשמה במרקט</a>
            <p class="door-login">כבר יש לך חשבון? <a :href="dashboardUrl" target="_blank" rel="noopener">כניסה לדשבורד</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['site', 'cdn_domain'],
    data() {
        return {
            plan: null,
            market_url: 'https://account.wizzo.market',
        }
    },
    computed: {
        displayPrice() {
            return this.plan ? (this.plan.price_with_vat || this.plan.price) : '';
        },
        dashboardUrl() {
            return 'https://dashboard.' + (this.site?.domain || 'wizzo.stream');
        },
    },
    mounted() {
        this.api({ action: 'plans/get', data: { id: this.$route.params.id}}, (data)=>{
            this.plan = data.data;
        })
    },
}
</script>

<style lang="scss">
#plan_view {
  background: var(--color2);
  min-height: 100vh;
  color: #fff;
}

.plan-hero {
  background: linear-gradient(180deg, rgba(10, 15, 30, 1) 0%, rgba(10, 15, 30, 0.85) 100%);
  border-bottom: 1px solid rgba(46, 247, 186, 0.08);
  padding: 100px 24px 40px;
  text-align: center;

  .back-link {
    color: var(--text-muted);
    font-size: var(--h6);
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 20px;
    transition: color 0.2s;
    &:hover { color: var(--color1); }
    i { font-size: 12px; }
  }

  .plan-hero-title {
    font-size: var(--h1);
    font-weight: 800;
    margin-bottom: 12px;
    .accent { color: var(--color1); }
  }

  .plan-hero-sub {
    color: var(--text-muted);
    font-size: var(--h4);
  }
}

.plan-body {
  padding: 40px 24px 80px;
  max-width: 1000px;
}

.plan-content {
  display: flex;
  gap: 32px;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
}

.plan-sidebar {
  width: 300px;
  flex-shrink: 0;

  @media (max-width: 768px) { width: 100%; }
}

.plan-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: var(--radius_s);
  padding: 28px;

  .plan-card-header {
    margin-bottom: 20px;
  }

  .plan-badge {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--color1);
    font-weight: 600;
    margin-bottom: 8px;
    display: block;
  }

  .plan-name {
    font-size: var(--h3);
    font-weight: 700;
    color: #fff;
  }

  .plan-price-row {
    display: flex;
    align-items: baseline;
    gap: 4px;
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);

    .plan-price { font-size: 48px; font-weight: 800; color: #fff; }
    .plan-currency { font-size: 22px; color: var(--text-muted); }
    .plan-period { font-size: 14px; color: var(--text-muted); margin-inline-start: 8px; }
  }

  .plan-features {
    display: flex;
    flex-direction: column;
    gap: 12px;

    li {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      color: var(--text-light);

      i { color: var(--color1); font-size: 13px; }
    }
  }

  .change-plan {
    display: block;
    text-align: center;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    color: var(--text-muted);
    font-size: 13px;
    transition: color 0.2s;
    &:hover { color: var(--color1); }
  }
}

.plan-main {
  flex: 1;
  min-width: 0;
}

.form-card {
  background: #fff;
  border-radius: var(--radius_s);
  padding: 40px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
  color: #1a1a2e;

  @media (max-width: 768px) { padding: 24px; }
}

.form-title {
  font-size: var(--h3);
  font-weight: 700;
  margin-bottom: 32px;
  color: #1a1a2e;
}

.submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  background: var(--color1);
  color: var(--color2);
  border: none;
  border-radius: var(--radius_xs);
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s ease;
  font-family: inherit;
  text-decoration: none;
  margin-top: 8px;

  &:hover { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(46, 247, 186, 0.3); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(46, 247, 186, 0.45); }
}

.market-door {
  text-align: center;
  padding: 56px 40px;

  @media (max-width: 768px) { padding: 40px 24px; }

  .door-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 24px;
    border-radius: 50%;
    background: var(--color1-dim);
    color: var(--color2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
  }

  .form-title { margin-bottom: 16px; }

  .door-text {
    color: #6b7280;
    font-size: var(--h5);
    line-height: 1.7;
    max-width: 460px;
    margin: 0 auto 32px;
    text-wrap: balance;
  }

  .submit-btn { display: inline-flex; padding: 0 40px; margin-top: 0; }

  .door-login {
    margin-top: 24px;
    font-size: 14px;
    color: #6b7280;

    a {
      color: #1a1a2e;
      font-weight: 600;
      text-decoration: underline;
      text-underline-offset: 3px;
      transition: color 0.2s;
      &:hover { color: #10b981; }
    }
  }
}
</style>
